import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import OverlapSection from 'Component/OverlapSection/OverlapSection';
import CtaSection from 'Component/CtaSection/CtaSection';
import TwoColumnSection from 'Component/TwoColumnSection/TwoColumnSection';
import MultiColumnFeature from 'Component/MultiColumnFeature/MultiColumnFeature';
import CardsCarousel from 'Component/CardsCarousel/CardsCarousel';

import IconsData from 'IconsData/PMS.json';
import TwoColumnData from 'TwoColumnData/PMS.json';
import { MultiColumnFeatureData } from 'MultiColumnFeatureData/PMS.js';
import CardsCarouselData from 'CardsCarouselData/PMS.json';

const PMS = () => {
	const images = useStaticQuery(IMAGES_QUERY);
	return (
		<Layout>
			<SEO title="Portfolio Management Services" description="" />
			<Hero
				heading="Portfolio Management Services"
				iconsData={IconsData}
				breadcrumbs={[
					{
						text: 'Invest',
						link: '#',
					},
					{
						text: 'Portfolio Management Services',
						link: '#',
					},
				]}
				ctaFormText="Interested in Portfolio Management Services?"
				customClass="bgPms"
			/>
			<OverlapSection
				heading="What is Portfolio Management Services?"
				description={[
					'Portfolio Management Services [PMS] is a more specialized way of managing your portfolio. Unlike a Mutual fund – A PMS typically has 20-25 stocks which are managed more dynamically. The objective of having a PMS is to generate returns higher than Equity Mutual funds. PMS products involve a bigger ticket size (minimum being 25 Lakhs), higher volatility, longer time horizon (at least 3 years), and more risk - taking capacity from investors.',
					<span>
						<br />
						<br />
					</span>,
					'With a minimum investment of Rs 25,00,000 and a trading & demat account one can get started with PMS immediately.',
				]}
			/>
			<TwoColumnSection
				heading="Why go for PMS? What are the Benefits of PMS?"
				data={TwoColumnData}
				images={images}
			/>
			<CtaSection
				heading="Looking at exploring our PMS products? Let’s connect!"
				aboutText="Looking to start a SIP instead? Check out"
				aboutTextLink="expected returns from direct mutual funds."
				aboutTextLinkUrl="/direct-mutual-funds"
			/>
			<MultiColumnFeature
				heading="Why invest in PMS via Moneyfront?"
				description="As a SEBI registered Investment advisor, Moneyfront engages in Mutual fund portfolio management while also advising our clients on best Investments for Portfolio management. We offer two types of Portfolio Management Services:"
				data={MultiColumnFeatureData}
				customClass="iconsLeft"
			/>
			<CardsCarousel
				description="The investment analysis and portfolio management team at Moneyfront will bring to the investor an array of PMS products from the best minds in the country. The following PMS products are available for investment via Moneyfront."
				data={CardsCarouselData}
				customClass="removeAboveMargin"
			/>
			<CtaSection
				heading="Ready to get started with PMS?"
				subheading="To begin, simply share your contact details with us, and our experts will get in touch with you."
				customClass="inFooter"
			/>
		</Layout>
	);
};

export default PMS;

const IMAGES_QUERY = graphql`
	{
		# Two Section Column Images
		individuallyManaged: file(
			relativePath: { eq: "pms/two-column/individually-managed.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		lowInvestment: file(
			relativePath: { eq: "pms/two-column/low-investment.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		directOwnership: file(
			relativePath: { eq: "pms/two-column/direct-ownership.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		highReturns: file(relativePath: { eq: "pms/two-column/high-returns.png" }) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
	}
`;
